module.exports = "/legacy/4c1c1a354918672bc79fcf756030187a.svg";